// extracted by mini-css-extract-plugin
export default {"container":"closeButton-module__container__xF6g4"};